import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import Modal from 'react-bootstrap/Modal';
import CustomInputField from '../../../../common/CustomInputField';
import CustomTextArea from '../../../../common/CustomTextArea';
import { changeSTatuss, getAdminVirtualWalletBalance, getLength } from '../../../../api/login/Login';
import * as Yup from 'yup';
import { Button, Form } from 'react-bootstrap';
import InputGroup from 'react-bootstrap/InputGroup';
import { ModalImgShow } from '../../../distributer/createUserDistributer/kycDetails/ModalImgShow';
import { ToastContainer, toast } from 'react-toastify';
import { baseUrlImage } from '../../../../baseUrl';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';

function PaymentUpdate({ show, handleClose, values, showLog, setshowLog, getPaymentRequest, page }) {
     
    const [showPassword, setShowPassword] = useState(false);
    console.log(values , "overdraft")

    const [selectedWallet, setSelectedWallet] = useState('main_wallet');
    const [adminBalances, setAdminBalances] = useState({
        main_wallet: 0,
        aeps_wallet: 0,
        cashback_wallet: 0,
    });
    const [loadingBalances, setLoadingBalances] = useState(false);

    const parseBal = (val) => {
        if (val === undefined || val === null || val === '') return 0;
        const num = parseFloat(val);
        return isNaN(num) ? 0 : num;
    };

    const fetchAdminBalances = async (isManual = false) => {
        setLoadingBalances(true);
        try {
            const res = await getAdminVirtualWalletBalance();
            const data = res?.data?.data || res?.data || res;
            if (data && (data.main_wallet !== undefined || data.admin_virtual_main_wallet !== undefined)) {
                setAdminBalances({
                    main_wallet: parseBal(data.main_wallet ?? data.admin_virtual_main_wallet),
                    aeps_wallet: parseBal(data.aeps_wallet ?? data.admin_virtual_aeps_wallet),
                    cashback_wallet: parseBal(data.cashback_wallet ?? data.admin_virtual_cashback_wallet),
                });
                setLoadingBalances(false);
                if (isManual) {
                    toast.success("Wallet balances refreshed!", { position: "top-right", autoClose: 1500 });
                }
                return;
            }
        } catch (err) {
            console.error("Failed to fetch admin virtual balances, trying getLength:", err);
        }

        try {
            const res2 = await getLength();
            const data2 = res2?.data?.data || res2?.data || res2;
            if (data2) {
                setAdminBalances({
                    main_wallet: parseBal(data2.admin_virtual_main_wallet ?? data2.main_wallet),
                    aeps_wallet: parseBal(data2.admin_virtual_aeps_wallet ?? data2.aeps_wallet),
                    cashback_wallet: parseBal(data2.admin_virtual_cashback_wallet ?? data2.cashback_wallet),
                });
                if (isManual) {
                    toast.success("Wallet balances refreshed!", { position: "top-right", autoClose: 1500 });
                }
            }
        } catch (err2) {
            console.error("getLength fallback error in PaymentUpdate:", err2);
            if (isManual) {
                toast.error("Failed to refresh balance");
            }
        } finally {
            setLoadingBalances(false);
        }
    };

    const [adminRemark, setAdminRemark] = useState("");

    const [initialValues, setInitialValues] = useState({
        user_name: "",
        amount: '',
        payment_date: '',
        remark: '',
        remarkByAdmin: "",
        pin: '',
        bank_name: '',
        bankRef: '',
        password: "",
    });
    const [initialStatus, setInitialStatus] = useState({
        status: "",
    });
    const handleStatus = (e) => {
        const val = e.target.value;
        setInitialStatus({
            status: val
        });
    };

    useEffect(() => {
        if (show && values?._id) {
            fetchAdminBalances();
            setSelectedWallet('main_wallet');
            setInitialStatus({ status: values?.status || "Pending" });
            setAdminRemark(values?.remarkByAdmin || "");
        }
    }, [show, values?._id]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        if (values?.paymentDate && !showLog) {
            const dates = formatDate(values?.paymentDate);
            const clonne = {
                user_name: values?.username,
                amount: values?.amount,
                payment_date: dates,
                message: '',
                bankRef: values?.bankRef,
                bank_name: values?.bank,
                remark: values?.remark,
                remarkByAdmin: values?.remarkByAdmin,
                receipt_img: values?.receipt_img,
                method: values?.method,
                password: "",
                status: values?.status,
            };
            setInitialValues(clonne);
        }
    }, [values?.paymentDate, showLog]);

    const currentAdminBal = Number(adminBalances[selectedWallet] || 0);
    const requestedAmount = Number(values?.amount || 0);
    const isInsufficient = initialStatus.status === 'Approved' && currentAdminBal < requestedAmount;

    const validate = (value) => {
        let errors = {};
       
        if (!value.payment_date) {
            errors.payment_date = "Payment Date is required";
        }
        if (!value.user_name) {
            errors.user_name = "User Name is required";
        }
        // if (!value.bank_name || values?.method != 'overdraft') {
        //     errors.bank_name = "Bank Name is required";
        // }
        if (!value.amount) {
            errors.amount = "Amount is required";
        }
        // if (!value.bankRef || values?.method != 'overdraft') {
        //     errors.bankRef = "Bank Ref is required";
        // }
        if (!value.password) {
            errors.password = "Password is required";
        }
        if (values.method != 'overdraft') {
            if (!value.bank_name) {
                errors.bank_name = "Bank Name is required";
            }
            if (!value.bankRef) {
                errors.bankRef = "Bank Ref is required";
            }
        }
       
        return errors;
    };

    const submitForm = async (values) => {
        const clone = {
            token: window.localStorage.getItem('userIdToken'),
            status: values.status,
            Payment: values._id,
            message: values.message,
            pin: values.pin,
            wallet_type: selectedWallet,
        };

        try {
            const response = await changeSTatuss(clone);
            if (response?.statusCode === 200) {
                toastSuccessMessage("Successfully updated payment status.");
                getPaymentRequest();
                handleClose();
            } else {
                toastErrorMessage(response.message);
            }
        } catch (error) {
            toastErrorMessage(error.message);
        }
    };

    const handleChange1 = (e) => {
        const { name, value } = e.target;
        setInitialValues(prevValues => ({
            ...prevValues,
            [name]: value
        }));
    };

    const validationSchema = Yup.object().shape({
        email: Yup.string().email('Invalid email address').required('Email is required'),
        password: Yup.string().min(6, 'Password must be at least 6 characters long').required('Password is required'),
        pin: Yup.string().length(4, 'PIN must be exactly 4 digits').required('PIN is required'),
    });

    const initialValues2 = {
        email: '',
        password: '',
        pin: '',
    };

    const toastErrorMessage = (message) => {
        toast.error(`Please Try Again ${message}`, {
            position: "top-right",
        });
    };

    const toastSuccessMessage = (message) => {
        toast.success(`${message}`, {
            position: "top-right",
        });
    };

    const submitForm2 = async (valuess) => {
        const targetStatus = initialStatus.status || "Approved";
        if (targetStatus === 'Approved' && isInsufficient) {
            toastErrorMessage(`Insufficient balance in ${selectedWallet.replace('_', ' ')}. Available: ₹${currentAdminBal.toFixed(2)}, Required: ₹${requestedAmount.toFixed(2)}`);
            return;
        }

        const clone = {
            status: targetStatus,
            Payment: values._id,
            message: initialValues?.message || `Disbursed via ${selectedWallet}`,
            email: valuess.email,
            password: valuess.password,
            remark: initialValues?.remark || "",
            remarkByAdmin: adminRemark || valuess.remarkByAdmin || initialValues?.remarkByAdmin || "",
            pin: valuess.pin,
            wallet_type: selectedWallet,
        };
        console.log("Submitting payment update payload:", clone);
        try {
            const response = await changeSTatuss(clone);
            if (response?.statusCode === 200) {
                toastSuccessMessage(response?.message);
                getPaymentRequest(page);
                handleClose();
            } else {
                toastErrorMessage(response.message);
            }
        } catch (error) {
            toastErrorMessage(error.message);
        }
    };

    const [show2, setShow2] = useState(false);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);
    const [cantain, setCantain] = useState({});

    const CLickImgShow2 = (url, str) => {
        handleShow2();
        setCantain({ url, str });
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} className='dilog-box newcuss' id="dilog-box">
                <Modal.Header closeButton>
                 
                    <span style={{fontSize:'20px' , color:'var(--nav)'}}>
                    <b>Update Payment</b>
                        </span>
                  
                  
                  
                </Modal.Header>
                
                <Modal.Body style={{paddingTop:'0px'}}>
                 <h4 className='py-2 px-2 text-primary'>Wallet Balance : <span>
                    {values?.user_wallet}
                    </span> </h4> 
                    {showLog ? (
                        <Formik
                            initialValues={initialValues2}
                            validationSchema={validationSchema}
                            onSubmit={submitForm2}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting
                            }) => (
                                <Form onSubmit={handleSubmit} className='cusformsnew mt-2'>
                                    {initialStatus.status === 'Approved' && (
                                        <div className="alert alert-info py-2 px-3 mb-3 rounded-3" style={{ fontSize: '0.86rem' }}>
                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                <strong>Disbursing From:</strong>
                                                <span className="badge bg-primary">
                                                    {selectedWallet === 'main_wallet' ? 'Main Wallet (MB)' : selectedWallet === 'aeps_wallet' ? 'AEPS Wallet (AW)' : 'Cashback Wallet (CW)'}
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span>Requested: <strong>₹{Number(requestedAmount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</strong></span>
                                                <div className="d-flex align-items-center gap-1">
                                                    <span>Available Supply: <strong className={currentAdminBal >= requestedAmount ? 'text-success' : 'text-danger'}>₹{Number(currentAdminBal).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</strong></span>
                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0 ms-1 text-primary shadow-none"
                                                        style={{ fontSize: '0.85rem', textDecoration: 'none' }}
                                                        onClick={(e) => { e.preventDefault(); fetchAdminBalances(true); }}
                                                        disabled={loadingBalances}
                                                        title="Refresh Balance"
                                                    >
                                                        <i className={`fas fa-refresh ${loadingBalances ? 'fa-spin' : ''}`}></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <Form.Group controlId="formEmail" className="mb-3">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            value={values.email}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={touched.email && !!errors.email}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.email}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group controlId="formPassword" className="mb-3">
                        <Form.Label>Password</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type={showPassword ? "text" : "password"}
                                name="password"
                                value={values.password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isInvalid={touched.password && !!errors.password}
                            />
                            <span
                                style={{width:'50px' , height:"42px" , marginTop:'4px', cursor:'pointer' , border:'1px solid #CCCCCC'}}
                                onClick={() => setShowPassword(!showPassword)}
                                tabIndex={-1}
                                className='d-flex justify-content-center align-items-center '
                            >
                                {showPassword ? <AiFillEyeInvisible size={16} /> : <AiFillEye size={16} />}
                            </span>
                            <Form.Control.Feedback type="invalid">
                                {errors.password}
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>

                                    <Form.Group controlId="formPin" className="mb-3">
                                        <Form.Label>TPIN</Form.Label>
                                        <Form.Control
                                            type="password"
                                            name="pin"
                                            value={values.pin}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={touched.pin && !!errors.pin}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.pin}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Button variant="danger" onClick={() => { setshowLog(false); }}>Cancel</Button>
                                    <Button variant="primary" type="submit" disabled={isSubmitting || isInsufficient} className="ms-2">
                                        {isSubmitting ? 'Submitting...' : isInsufficient ? 'Insufficient Supply' : 'Submit'}
                                    </Button>
                                </Form>
                            )}
                        </Formik>
                    ) : (
                        <Formik
                            initialValues={initialValues}
                            validate={validate}
                            onSubmit={submitForm}
                            enableReinitialize
                        >
                            {(formik) => {
                                const {
                                    values,
                                    handleChange,
                                    handleSubmit,
                                    errors,
                                    touched,
                                    handleBlur,
                                } = formik;
                                return (
                                    <form onSubmit={handleSubmit} className='mt-2'>
                                        <div className="row">
                                            <div className="col-xl-6 mb-3">
                                                <CustomInputField
                                                    type="text"
                                                    value={values?.user_name}
                                                    hasError={errors.user_name && touched.user_name}
                                                    onChange={handleChange1}
                                                    onBlur={handleBlur}
                                                    errorMsg={errors.user_name}
                                                    autoFocus={true}
                                                    readOnly
                                                    id="user_name"
                                                    name="user_name"
                                                    placeholder="User Name"
                                                />
                                            </div>
                                            <div className="col-xl-6 mb-3">
                                                <CustomInputField
                                                    type="date"
                                                    value={values?.payment_date}
                                                    hasError={errors.payment_date && touched.payment_date}
                                                    onChange={handleChange1}
                                                    onBlur={handleBlur}
                                                    errorMsg={errors.payment_date}
                                                    autoFocus={true}
                                                    readOnly
                                                    id="payment_date"
                                                    name="payment_date"
                                                    placeholder="Payment Date"
                                                />
                                            </div>
                                            <div className="col-xl-6 mb-3">
                                                {/* <select className="form-select" aria-label="Default select example" onChange={handleChange1} value={values?.method} name="method"> */}
                                                    {/* <option>Select Method</option>
                                                    <option value='neft'>NEFT</option>
                                                    <option value='rtgs'>RTGS</option>
                                                    <option value="IMPS">IMPS</option>
                                                    <option value="cashdeposit">CASH Deposit</option> */}
                                                    {/* <option value="qrpayment">QR PAYMENT</option>
                                                    <option value="upipayment">UPI PAYMENT</option> */}
                                                {/* </select> */}
                                                <CustomInputField
                                                    type="text"
                                                    value={values?.method}
                                                    hasError={errors.method && touched.method}
                                                    onChange={handleChange1}
                                                    onBlur={handleBlur}
                                                    errorMsg={errors.method}
                                                    autoFocus={true}
                                                    readOnly
                                                    id="method"
                                                    name="method"
                                                    placeholder="Payment Method"
                                                />
                                            </div>
                                            <div className="col-xl-6 mb-3">
                                                <CustomInputField
                                                    type="text"
                                                    value={values?.bank_name}
                                                    hasError={errors.bank_name && touched.bank_name}
                                                    onChange={handleChange1}
                                                    onBlur={handleBlur}
                                                    errorMsg={errors.bank_name}
                                                    autoFocus={true}
                                                    readOnly
                                                    id="bank_name"
                                                    name="bank_name"
                                                    placeholder="Bank name"
                                                />
                                            </div>
                                            <div className="col-xl-6 mb-3">
                                                <CustomInputField
                                                    type="number"
                                                    value={values?.amount}
                                                    hasError={errors.amount && touched.amount}
                                                    onChange={handleChange1}
                                                    onBlur={handleBlur}
                                                    errorMsg={errors.amount}
                                                    autoFocus={true}
                                                    readOnly
                                                    id="amount"
                                                    name="amount"
                                                    placeholder="Amount"
                                                />
                                            </div>
                                            <div className="col-xl-6 mb-3">
                                                <CustomInputField
                                                    type="text"
                                                    value={values?.bankRef}
                                                    hasError={errors.bankRef && touched.bankRef}
                                                    onChange={handleChange1}
                                                    onBlur={handleBlur}
                                                    errorMsg={errors.bankRef}
                                                    autoFocus={true}
                                                    readOnly
                                                    id="bankRef"
                                                    name="bankRef"
                                                    placeholder="Bank Ref"
                                                />
                                            </div>
                                            <div className="col-xl-12 mb-3">
                                                <label className="form-label fw-bold mb-1" style={{ fontSize: '0.9rem' }}>Status</label>
                                                <select
                                                    className="form-select"
                                                    aria-label="Default select example"
                                                    value={initialStatus.status || values?.status || ""}
                                                    name="status"
                                                    id='status'
                                                    onChange={handleStatus}
                                                    onBlur={handleBlur}
                                                >
                                                    <option value="" disabled hidden>Select Status</option>
                                                    <option value="Pending">Pending</option>
                                                    <option value="Approved">Approved</option>
                                                    <option value="In progress">In progress</option>
                                                    <option value="Rejected">Rejected</option>
                                                </select>
                                            </div>

                                            {initialStatus.status === 'Approved' && (
                                                <div className="col-xl-12 mb-3">
                                                    <div className="p-3 rounded-3 border shadow-sm" style={{ backgroundColor: '#f8faff' }}>
                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <label className="form-label fw-bold mb-0 text-dark" style={{ fontSize: '0.9rem' }}>
                                                                <i className="fa-solid fa-wallet text-primary me-2"></i>
                                                                Disburse From Admin Supply
                                                            </label>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <span className={`badge ${currentAdminBal >= requestedAmount ? 'bg-success' : 'bg-danger'} px-2 py-1`}>
                                                                    {loadingBalances ? 'Loading...' : `Available: ₹${currentAdminBal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}
                                                                </span>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-primary shadow-none d-inline-flex align-items-center"
                                                                    style={{ padding: '2px 8px', fontSize: '0.75rem', borderRadius: '4px', cursor: 'pointer', height: '26px' }}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        fetchAdminBalances(true);
                                                                    }}
                                                                    disabled={loadingBalances}
                                                                    title="Click to refresh latest wallet balances"
                                                                >
                                                                    <i className={`fas fa-refresh ${loadingBalances ? 'fa-spin' : ''} me-1`}></i>
                                                                    Refresh
                                                                </button>
                                                            </div>
                                                        </div>
                                                        
                                                        <select
                                                            className="form-select form-select-md mb-2 shadow-none"
                                                            value={selectedWallet}
                                                            onChange={(e) => setSelectedWallet(e.target.value)}
                                                            disabled={loadingBalances}
                                                        >
                                                            <option value="main_wallet">Main Wallet (MB) - Available: ₹{Number(adminBalances.main_wallet).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</option>
                                                            <option value="aeps_wallet">AEPS Wallet (AW) - Available: ₹{Number(adminBalances.aeps_wallet).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</option>
                                                            <option value="cashback_wallet">Cashback Wallet (CW) - Available: ₹{Number(adminBalances.cashback_wallet).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</option>
                                                        </select>

                                                        {isInsufficient ? (
                                                            <div className="alert alert-danger d-flex align-items-start mb-0 py-2 px-3 rounded-2" style={{ fontSize: '0.84rem' }}>
                                                                <i className="fa-solid fa-triangle-exclamation me-2 mt-1 text-danger"></i>
                                                                <div>
                                                                    <strong>Insufficient Virtual Balance!</strong><br />
                                                                    Request requires <strong>₹{requestedAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</strong>, but selected supply has only <strong>₹{currentAdminBal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</strong>.<br />
                                                                    <a href="/admin/wallet/add/virtual-wallet" target="_blank" rel="noreferrer" className="text-danger fw-bold text-decoration-underline">
                                                                        Click here to load virtual digits
                                                                    </a> before approving.
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="text-muted small d-flex justify-content-between">
                                                                <span>Disbursement Source: <strong className="text-dark">{selectedWallet === 'main_wallet' ? 'Main Wallet (MB)' : selectedWallet === 'aeps_wallet' ? 'AEPS Wallet (AW)' : 'Cashback Wallet (CW)'}</strong></span>
                                                                <span className="text-success fw-bold">✓ Sufficient Balance</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            <div className="col-xl-6 mb-3">
                                                <CustomTextArea
                                                    type="text"
                                                    value={values?.remark}
                                                    hasError={errors.remark && touched.remark}
                                                    onChange={handleChange1}
                                                    onBlur={handleBlur}
                                                    errorMsg={errors.remark}
                                                    autoFocus={true}
                                                    id="remark"
                                                    name="remark"
                                                    placeholder="Remarks"
                                                    readOnly
                                                />
                                            </div>
                                            <div className="col-xl-6 mb-3">
                                                <CustomTextArea
                                                    type="text"
                                                    value={adminRemark || values.remarkByAdmin || ""}
                                                    hasError={errors.remarkByAdmin && touched.remarkByAdmin}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        setAdminRemark(e.target.value);
                                                    }}
                                                    onBlur={handleBlur}
                                                    errorMsg={errors.remarkByAdmin}
                                                    autoFocus={true}
                                                    id="remarkByAdmin"
                                                    name="remarkByAdmin"
                                                    placeholder="Review"
                                                />
                                            </div>
                                            {values?.receipt_img && 
                                            <div className="col-xl-12 mb-3">
                                                <h5>SLIP</h5>
                                                <div onClick={() => { CLickImgShow2(values?.receipt_img, 'SLIP'); }} style={{ cursor: "pointer" }}>
                                                    <img style={{ width: "100px", height: "100px" }} src={`${baseUrlImage}${values?.receipt_img}`} alt='ricept' />
                                                </div>
                                            </div>}
                                            <div className='border-top'>
                                                <button 
                                                    className="btn btn-primary pd-x-20 rounded-2" 
                                                    type="button" 
                                                    onClick={() => { setshowLog(true); }} 
                                                    disabled={isInsufficient}
                                                    title={isInsufficient ? "Cannot approve: Insufficient admin virtual balance" : "Proceed to confirmation"}
                                                    style={{ marginTop: "15px" }}
                                                >
                                                    {isInsufficient ? 'Insufficient Virtual Supply' : 'Update'}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                );
                            }}
                        </Formik>
                    )}
                   
                </Modal.Body>
            </Modal>
            <Modal
                show={show2}
                onHide={handleClose2}
                keyboard={false}
                size='lg'
                className='naomedClass'
            >
                <ModalImgShow handleClose={handleClose2} cantain={cantain} />
            </Modal>
            <ToastContainer className={"text-center text-uppercase"} />
        </>
    );
}

export default PaymentUpdate;
